module.exports = __webpack_public_path__ + "static/media/crypto.b27ccadb.png";